module.exports = __webpack_public_path__ + "img/cftools.e6b7ef49.svg";